import {
	FILTER_LIST_GENERIC_ACTIVITY_LIST_SORT,
	FILTER_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE,
} from 'src/stores/filterList/localStorageKeys';
import { TSMap } from 'typescript-map';

import { DateRangeSelection } from 'src/models/common';
import { FilterBoxes, FilterModule, FilterUsers } from 'src/models/filter';
import { FilterListItem } from 'src/models/filterList';
import {
	ActivityListTypeEnum,
	GenericActivityListPagination,
	GenericActivityListSort,
} from 'src/models/genericActivityList';
import { PreconfiguredTimeRanges } from 'src/models/miniCalendar';
import { SerializedQuery } from 'src/models/query';

interface FilterListStateInterface {
	activeQueryIdentifierByListType: TSMap<ActivityListTypeEnum, string>;
	dateFilter: DateRangeSelection | string;
	dateTimeRangeFilter: PreconfiguredTimeRanges;
	directionFilter: 'combined' | 'in' | 'out';
	filterBoxes: Array<FilterBoxes>;
	filterList: Array<FilterListItem>;
	filterListSliced: Map<number, Array<FilterListItem>>;
	filterListTotalCount: number;
	filterModules: Array<FilterModule>;
	filterUsers: Array<FilterUsers>;
	filteredBoxIds: Array<string>;
	filteredModuleIds: Array<string>;
	filteredUsers: Array<FilterUsers>;
	listViewModeLarge: boolean;
	pagination: TSMap<ActivityListTypeEnum, GenericActivityListPagination>;
	queryStoreSubscriptions: Array<SerializedQuery>;
	selectedSharedQueryId: string;
	sort: TSMap<ActivityListTypeEnum, GenericActivityListSort>;
}

function state(): FilterListStateInterface {
	return {
		activeQueryIdentifierByListType: new TSMap<ActivityListTypeEnum, string>(),
		dateFilter: new Date().toISOString().split('T')[0],
		dateTimeRangeFilter: PreconfiguredTimeRanges.TODAY,
		directionFilter: 'combined',
		filterBoxes: [],
		filterList: [],
		filterListSliced: new Map<number, Array<FilterListItem>>(),
		filterListTotalCount: 0,
		filterModules: [],
		filterUsers: [],
		filteredBoxIds: [],
		filteredModuleIds: [],
		filteredUsers: [],
		listViewModeLarge:
			localStorage.getItem(FILTER_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) !== null
				? /true/i.test(
						localStorage.getItem(FILTER_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) as 'false' | 'true'
					)
				: true,
		pagination: new TSMap<ActivityListTypeEnum, GenericActivityListPagination>([
			[ActivityListTypeEnum.FILTER, { page: 1, rowsPerPage: 100 }],
		]),
		queryStoreSubscriptions: [],
		selectedSharedQueryId: '',
		sort:
			localStorage.getItem(FILTER_LIST_GENERIC_ACTIVITY_LIST_SORT) !== null
				? new TSMap<ActivityListTypeEnum, GenericActivityListSort>().fromJSON(
						JSON.parse(localStorage.getItem(FILTER_LIST_GENERIC_ACTIVITY_LIST_SORT) as string)
					)
				: new TSMap<ActivityListTypeEnum, GenericActivityListSort>([
						[
							ActivityListTypeEnum.ALL,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.FILTER,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.ALL_MODULE_LISTS_AT_ONCE,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.MINE,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.OPEN,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
					]),
	};
}

export default state;
